import React, {useMemo, useState} from 'react'
import ModalAddRole from '../../../_payairo/partials/widgets/_new/modal/ModalAddRole'
import {useLayout} from '../../../_payairo/layout/core'
import {useAuth} from '../../modules/auth'

/**
 * Admin / Super Admin / Developer: "Add Role" opens Create Role (permission group) modal.
 */
const RoleManagementRightToolbar = () => {
  const {currentUser, auth} = useAuth()
  const [showCreateRole, setShowCreateRole] = useState(false)
  const {setRightTolbar} = useLayout()

  const canAddRole = true

  if (!canAddRole) {
    return null
  }

  return null
}

export default RoleManagementRightToolbar
